import React from 'react';

import ExternalScript from '../externalScript/ExternalScript';

const GOOGLE_MERCHANT_ID = 367592799;

export default class GoogleReviewsIframe extends React.PureComponent {
  handleLoad = () => {
    if (window.merchantwidget) {
      window.merchantwidget.start({
        merchant_id: GOOGLE_MERCHANT_ID,
        position: 'LEFT_BOTTOM',
      });
    }
  };

  render() {
    return (
      <ExternalScript
        id="merchantWidgetScript"
        src="https://www.gstatic.com/shopping/merchant/merchantwidget.js"
        onLoad={this.handleLoad}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/reviews/GoogleReviewsIframe.js